<div style="height: 300px">
    <blue-loading-spinner [showSpinner]="true"></blue-loading-spinner>
</div>